import { loginApi } from "./loginApi";

export const loginSetData = async (
  lang,
  credintial,
  setAuth,
  setMessageResponse,
  setCookie,
  setBtnLoader
) => {
  const response = await loginApi(credintial, lang);
  // set user data
  if (response.success) {
    localStorage.setItem(
      "amar_management_name",
      response.res.data.data.firstName
    );
    localStorage.setItem(
      "amar_management_role",
      response.res.data.data.role
    );
    setCookie("__t0ken_amar_management", response.res.data.data.token);
    setAuth((prev) => ({
      ...prev,
      isAuthenticated: true,
      role: response.res.data.data.role,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
